import './App.css';
import Landing from "./components/Landing";
import {useEffect, useState} from "react";
import jwt from "jsonwebtoken";
import FunctionsData from "./functions/FunctionsData";
const queryString = require('query-string');

function App() {
	
	const [t, setT] = useState(false);
	const [verifyToken, setVerifyToken] = useState(null);
	const [verifyTokenLoading, setVerifyTokenLoading] = useState(true);
	useEffect(() => {
		fetch(FunctionsData.getApiUrl('/api/search/a1/startup'))
			.then(res => res.json())
			.then((r) => {
				// console.log(r);
				sessionStorage.setItem("tkn", r.data);
				setT(true);
			});
	}, []);
	
	useEffect(() => {
		
		if(t === true) {
			//console.log(window.location.search)
			const queryParams = queryString.parse(window.location.search);
			//console.log(queryParams) //pizza
			try {
				if(queryParams.vrflnk !== null) {
					const dec = jwt.decode(queryParams.vrflnk);
					if(dec.id > 0) {
						FunctionsData.postData(
							FunctionsData.getApiUrl('/api/register/verify'),
							{vrflnk:queryParams.vrflnk}
						).then((r) => {
							//console.log('/api/register/verify', r);
							if(r.success) {
								setVerifyToken(true);
								setVerifyTokenLoading(false);
							}
						})
					}
				}
			}catch(e) {
				setVerifyToken(false);
				setVerifyTokenLoading(false);
			}
		}
		setVerifyTokenLoading(false);
		
	}, [t]);
	
	if(t === false) return null;
	return (
		<div className="App">
			<EmailVerificationBanner verifyToken={verifyToken} />
			{
				(verifyToken === false) ?
					<Landing/>
					: undefined
			}
		</div>
	);
}

const EmailVerificationBanner = (props) => {
	if(props.verifyToken === true)
	return (
		<div style={{
			width:'100%', margin:'60px', fontWeight:'bold',textAlign:'center'
		}}>
			<div style={{margin:20}}><img src="https://workvision.sgp1.digitaloceanspaces.com/spca/snipnchip_logo.png" style={{height:100}} /></div>
			<div>Thank you, your email has been verified.</div>
		
		</div>
	)
	
	return null;
}

//sdasdas

export default App;
